import type {AmplitudeUnlockChoiceButtonCategory} from "../../tracking/amplitude/track_amplitude_button_click";
import type {AmplitudeUnlockChoiceModalName} from "../../tracking/amplitude/track_amplitude_view_modal";
import {UnlockChoiceOptionId} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface UnlockChoiceTrackingConfig {
    modalName: AmplitudeUnlockChoiceModalName;
    buttonCategory: AmplitudeUnlockChoiceButtonCategory;
    values: Partial<Record<UnlockChoiceOptionId, string>>;
    // the clicks report the page under the modal, as its view does
    isClickLocationTracked?: boolean;
}

const OFFER_CHOICE_VALUES = {offer: "non_binding_offer", meeting: "schedule_meeting", reservation: "free_reservation"} satisfies Partial<
    Record<UnlockChoiceOptionId, string>
>;

const OFFER_CHOICE_TRACKING: UnlockChoiceTrackingConfig = {
    modalName: "post_price_reveal",
    buttonCategory: "rp_post_price_reveal",
    values: OFFER_CHOICE_VALUES,
    isClickLocationTracked: true
};

const getContentChoiceTracking = (
    modalName: AmplitudeUnlockChoiceModalName,
    buttonCategory: AmplitudeUnlockChoiceButtonCategory,
    valuePrefix: string
): UnlockChoiceTrackingConfig => ({
    modalName,
    buttonCategory,
    values: {full_package: `${valuePrefix}_and_offer`, content_only: `${valuePrefix}_only`}
});

export const UNLOCK_CHOICE_TRACKING: Record<UnlockChoiceEntryPoint, UnlockChoiceTrackingConfig> = {
    [UnlockChoiceEntryPoint.PRICE]: OFFER_CHOICE_TRACKING,
    [UnlockChoiceEntryPoint.LEAD]: OFFER_CHOICE_TRACKING,
    [UnlockChoiceEntryPoint.FLOOR_PLAN]: getContentChoiceTracking("download_floor_plan", "rp_download_floor_plan", "floor_plan"),
    [UnlockChoiceEntryPoint.PRICE_HISTORY]: getContentChoiceTracking("price_history", "rp_price_history", "price_history"),
    [UnlockChoiceEntryPoint.VENDOR_REPORT]: getContentChoiceTracking("developer_report", "rp_developer_report", "developer_report"),
    [UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS]: getContentChoiceTracking("construction_photos", "rp_construction_photos", "construction_photos"),
    [UnlockChoiceEntryPoint.AREA_PHOTOS]: getContentChoiceTracking("area_photos", "rp_area_photos", "area_photos"),
    [UnlockChoiceEntryPoint.FAQ]: getContentChoiceTracking("faq", "rp_faq", "faq")
};
import type {AmplitudeUnlockChoiceButtonCategory} from "../../tracking/amplitude/track_amplitude_button_click";
import type {AmplitudeUnlockChoiceModalName} from "../../tracking/amplitude/track_amplitude_view_modal";
import {UnlockChoiceOptionId} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

interface UnlockChoiceTrackingConfig {
    modalName: AmplitudeUnlockChoiceModalName;
    buttonCategory: AmplitudeUnlockChoiceButtonCategory;
    values: Partial<Record<UnlockChoiceOptionId, string>>;
    // the clicks report the page under the modal, as its view does
    isClickLocationTracked?: boolean;
}

const OFFER_CHOICE_VALUES = {offer: "non_binding_offer", meeting: "schedule_meeting", reservation: "free_reservation"} satisfies Partial<
    Record<UnlockChoiceOptionId, string>
>;

const OFFER_CHOICE_TRACKING: UnlockChoiceTrackingConfig = {
    modalName: "post_price_reveal",
    buttonCategory: "rp_post_price_reveal",
    values: OFFER_CHOICE_VALUES,
    isClickLocationTracked: true
};

const getContentChoiceTracking = (
    modalName: AmplitudeUnlockChoiceModalName,
    buttonCategory: AmplitudeUnlockChoiceButtonCategory,
    valuePrefix: string
): UnlockChoiceTrackingConfig => ({
    modalName,
    buttonCategory,
    values: {full_package: `${valuePrefix}_and_offer`, content_only: `${valuePrefix}_only`}
});

export const UNLOCK_CHOICE_TRACKING: Record<UnlockChoiceEntryPoint, UnlockChoiceTrackingConfig> = {
    [UnlockChoiceEntryPoint.PRICE]: OFFER_CHOICE_TRACKING,
    [UnlockChoiceEntryPoint.LEAD]: OFFER_CHOICE_TRACKING,
    [UnlockChoiceEntryPoint.FLOOR_PLAN]: getContentChoiceTracking("download_floor_plan", "rp_download_floor_plan", "floor_plan"),
    [UnlockChoiceEntryPoint.PRICE_HISTORY]: getContentChoiceTracking("price_history", "rp_price_history", "price_history"),
    [UnlockChoiceEntryPoint.VENDOR_REPORT]: getContentChoiceTracking("developer_report", "rp_developer_report", "developer_report"),
    [UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS]: getContentChoiceTracking("construction_photos", "rp_construction_photos", "construction_photos"),
    [UnlockChoiceEntryPoint.AREA_PHOTOS]: getContentChoiceTracking("area_photos", "rp_area_photos", "area_photos"),
    [UnlockChoiceEntryPoint.FAQ]: getContentChoiceTracking("faq", "rp_faq", "faq")
};
